import { FC } from 'react';

import Breadcrumb, { BreadcrumbItem } from 'view/section/Breadcrumb/Breadcrumb';
import { SolicitacaoLink } from 'view/section/SolicitacaoLink/SolicitacaoLink';
import { SolicitacaoServicoPageViewProps } from './SolicitacaoServicoPage';

interface SolicitacaoServicoPageBreadcrumbsProps extends SolicitacaoServicoPageViewProps {}


export const SolicitacaoServicoPageBreadcrumbs: FC<SolicitacaoServicoPageBreadcrumbsProps> = ({idSolicitacao, solicitacao}) => {
  return <Breadcrumb>
    <BreadcrumbItem href="/">Início</BreadcrumbItem>
    <BreadcrumbItem href="/solicitacoes">Solicitações</BreadcrumbItem>
    <BreadcrumbItem>
      {
        idSolicitacao
          ? (<><SolicitacaoLink solicitacao={idSolicitacao} />{` - ${solicitacao?.titulo}`}</>)
          : 'Nova solicitação de serviço'
      }
    </BreadcrumbItem>
  </Breadcrumb>
}